var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useCallback } from 'react';
import { Input } from '../input.js';
import { useField } from 'formik';
import { inputPattern } from '@navinc/utils';
/**
 * PatternInput - A generic text input that works with Vanilla Masker's `toPattern`
 *
 * `<PatternInput pattern="99-99-99" value="123456" />` the value will be reformatted and displayed as "12-34-56"
 */
export const PatternInput = (_a) => {
    var { name, pattern, onBlur, onChange, invalidOnTouched = true } = _a, props = __rest(_a, ["name", "pattern", "onBlur", "onChange", "invalidOnTouched"]);
    const [field, meta, { setValue }] = useField({ name });
    const toInputPattern = useCallback((value) => {
        if (typeof pattern !== 'string') {
            console.error('PatternInput requires a string `pattern` property');
            return value;
        }
        return inputPattern(value, pattern);
    }, [pattern]);
    useEffect(() => {
        const converted = toInputPattern(field.value);
        if (converted !== field.value) {
            // Ensure initial value stored in parent form is formatted correctly
            setValue(converted);
        }
    }, [field.value, setValue, toInputPattern]);
    return (_jsx(Input, Object.assign({ type: "text", name: name, value: field.value, onChange: (e) => {
            const value = toInputPattern(e.target);
            setValue(value);
            onChange && onChange(e);
        }, onBlur: (e) => {
            field.onBlur(e);
            onBlur && onBlur(e);
        }, errors: (!invalidOnTouched || meta.touched) && meta.error, isInvalid: (!invalidOnTouched || meta.touched) && !!meta.error, hasSpaceForErrors: true }, props)));
};
//# sourceMappingURL=pattern-input.js.map